import {ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot} from "@angular/router";
import {EMPTY, Observable, of} from "rxjs";
import {
    LeagueCompetitorResult, DEFAULT_PAGE_SIZE,
    LeagueResultsFilter,
    PagedFilter,
    Pages, LeagueStandingsFilter, LeagueStandingsRace
} from "@model";
import {LeagueResultsService, LeagueStandingsService} from "@services";
import {inject} from "@angular/core";
import {LANDING_ROUTE, ORGANISER_DASHBOARD} from "../../app-routing.module";
import {LeagueRoundResultMeta} from "../../model/league/league-round-result-meta";
import {extractIdFromSlug} from "../../utility/slug-helper";

export const LeagueStandingsMetaResolver: ResolveFn<Observable<LeagueCompetitorResult[]> | any> =
    (route: ActivatedRouteSnapshot,
     _: RouterStateSnapshot,
     router: Router = inject(Router),
     leagueStandingsService: LeagueStandingsService = inject(LeagueStandingsService)): Observable<LeagueCompetitorResult[]> | any => {
        const isAdmin : boolean = route.data['isAdmin'] ?? false;
        const leagueId = route.queryParams['leagueId']
            ? +route.queryParams['leagueId']
            : extractIdFromSlug(route.parent?.params['slug'] ?? '') ?? 0;
        if (!leagueId) {
           router.navigate(isAdmin ? [ORGANISER_DASHBOARD] : [LANDING_ROUTE]);
           return EMPTY;
        }
        return leagueStandingsService.getStandingsMeta(leagueId, isAdmin);
    }


export const LeagueResultsAvailableRacesResolver: ResolveFn<Observable<LeagueStandingsRace[]> | any> =
    (route: ActivatedRouteSnapshot,
     _: RouterStateSnapshot,
     router: Router = inject(Router),
     leagueResultsService: LeagueResultsService = inject(LeagueResultsService)): Observable<LeagueStandingsRace[]> | any => {

        const leagueId = +route.queryParams['leagueId'];
        if (!leagueId) {
            router.navigate([ORGANISER_DASHBOARD]);
            return EMPTY;
        }

        return leagueResultsService.getAvailableRaces(leagueId);
}